module.exports = __webpack_public_path__ + "img/logo_pefc.321186c0.png";